import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { EventApi } from 'api/ApiHelper';
import { eventsQueryKey } from 'queries/events/queryKey';

export const useParticipateEventMutation = (options?: UseMutationOptions<ResponseDto, unknown, number>) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (eventId: number) => EventApi.participateEvent(eventId),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: eventsQueryKey.eventParticipated(variables) });
      options?.onSuccess?.(data, variables, context);
    },
  });
};
